module.exports = "/_next/static/videos/mainvisual-video-S-9a63670c27ae7156f1eb5c4c46536908.mp4";